<template>
  <div class="section aragon diagonal gradient" id="landing_community">
    <div class="ui middle aligned very relaxed center aligned stackable grid">
      <div class="twelve wide column">
        <h1 class="ui inverted header">
          Aragon Network token sale
          <div class="ui hidden half divider"></div>
          <div class="sub header">Create and manage unstoppable organizations</div>
        </h1>
        <div class="ui hidden divider"></div>
        <div class="ui hidden divider"></div>
        <div class="ui hidden divider"></div>
        <div class="ui hidden divider"></div>
        <div v-if="saleState === 0">
          <img class="ui small centered image" src="../assets/info/coin.png">
          <h1 class="ui inverted header">
            May 17th
            <div class="sub header">Exact time (block number) and address will be announced on Monday 15th</div>
          </h1>
        </div>
        <div v-if="saleState !== 0">
          <div class="ui inverted two statistics" v-if="ready">
            <ether v-if="saleState !== 1"></ether>
            <dollar v-if="saleState !== 1"></dollar>
          </div>
          <div class="ui hidden divider"></div>
          <div class="ui hidden divider"></div>
          <div class="ui hidden divider"></div>
          <h2 class="ui inverted header">
            🎉 Sale is closed! 🎉
            <div class="sub header">Thanks to everyone who participated.</div>
          </h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Ether from './stats/Ether'
import Dollar from './stats/Dollar'
import Countdown from './stats/Countdown'

import EthAddress from './EthAddress'
import Conversor from './Conversor'
import Shifty from './Shifty'
import Disclaimer from './Disclaimer'

export default {
  name: 'hero',
  components: {
    Ether,
    Dollar,
    Countdown,

    EthAddress,
    Conversor,
    Shifty,
    Disclaimer,
  },
  computed: {
    saleState() {
      return 3
    },
    ready() {
      return this.$store.state.ready
    },
    termsAccepted() {
      return this.$store.state.termsAccepted
    },
  },
}
</script>

<style scoped>
h1 {
  font-size: 3.5rem !important;
}
.sub.header {
  font-size: 1.5rem !important;
}
.disabled {
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// Hero.vue?a50587ea